export default __webpack_public_path__ + "static/media/frontend.6532aa86.png";